import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import videoEffectsJson from '../../../entities/data/video_effects.json'
import imageEffectsJson from '../../../entities/data/image_effects.json'
import type { EffectType } from '../../../shared/types/EffectType'
import type { PaymentPackType } from '../../../shared/types/PaymentPackType'
import {PaymentProviderEnum} from "../../../shared/types/PaymentProviderEnum.ts";

interface PresetsState {
  videoEffects: EffectType[]
  imageEffects: EffectType[]
  paymentProviders: PaymentProviderEnum[]
  paymentPacks: Record<PaymentProviderEnum, PaymentPackType[]>
}

const videoEffectsData = videoEffectsJson as EffectType[]
const imageEffectsData = imageEffectsJson as EffectType[]

const initialState: PresetsState = {
  videoEffects: videoEffectsData,
  imageEffects: imageEffectsData,
  paymentProviders: [],
  paymentPacks: {} as Record<PaymentProviderEnum, PaymentPackType[]>
}

export const presetsSlice = createSlice({
  name: 'presets',
  initialState,
  reducers: {
    setVideoEffects: (state, action: PayloadAction<EffectType[]>) => {
      state.videoEffects = action.payload
    },
    setImageEffects: (state, action: PayloadAction<EffectType[]>) => {
      state.imageEffects = action.payload
    },
    setPaymentProviders: (state, action: PayloadAction<PaymentProviderEnum[]>) => {
      state.paymentProviders = action.payload
    },
    setPaymentPacks: (state, action: PayloadAction<Record<PaymentProviderEnum, PaymentPackType[]>>) => {
      state.paymentPacks = action.payload
    },
  },
})

export const { setVideoEffects, setImageEffects, setPaymentPacks, setPaymentProviders } = presetsSlice.actions

export default presetsSlice.reducer
